/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityDataleaksInnerData } from './MonitEntityDataleaksInnerData';
import {
    MonitEntityDataleaksInnerDataFromJSON,
    MonitEntityDataleaksInnerDataFromJSONTyped,
    MonitEntityDataleaksInnerDataToJSON,
} from './MonitEntityDataleaksInnerData';

/**
 * 
 * @export
 * @interface MonitEntityDataleaksSumResponse
 */
export interface MonitEntityDataleaksSumResponse {
    /**
     * 
     * @type {Array<MonitEntityDataleaksInnerData>}
     * @memberof MonitEntityDataleaksSumResponse
     */
    events?: Array<MonitEntityDataleaksInnerData>;
    /**
     * 
     * @type {Array<MonitEntityDataleaksInnerData>}
     * @memberof MonitEntityDataleaksSumResponse
     */
    features?: Array<MonitEntityDataleaksInnerData>;
    /**
     * 
     * @type {Array<MonitEntityDataleaksInnerData>}
     * @memberof MonitEntityDataleaksSumResponse
     */
    main_leaks?: Array<MonitEntityDataleaksInnerData>;
}

/**
 * Check if a given object implements the MonitEntityDataleaksSumResponse interface.
 */
export function instanceOfMonitEntityDataleaksSumResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityDataleaksSumResponseFromJSON(json: any): MonitEntityDataleaksSumResponse {
    return MonitEntityDataleaksSumResponseFromJSONTyped(json, false);
}

export function MonitEntityDataleaksSumResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDataleaksSumResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(MonitEntityDataleaksInnerDataFromJSON)),
        'features': !exists(json, 'features') ? undefined : ((json['features'] as Array<any>).map(MonitEntityDataleaksInnerDataFromJSON)),
        'main_leaks': !exists(json, 'main_leaks') ? undefined : ((json['main_leaks'] as Array<any>).map(MonitEntityDataleaksInnerDataFromJSON)),
    };
}

export function MonitEntityDataleaksSumResponseToJSON(value?: MonitEntityDataleaksSumResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(MonitEntityDataleaksInnerDataToJSON)),
        'features': value.features === undefined ? undefined : ((value.features as Array<any>).map(MonitEntityDataleaksInnerDataToJSON)),
        'main_leaks': value.main_leaks === undefined ? undefined : ((value.main_leaks as Array<any>).map(MonitEntityDataleaksInnerDataToJSON)),
    };
}

